import React from 'react';
import _ from 'lodash';
import { object, func } from 'prop-types';
import { I18n, getContext } from '@fiverr-private/fiverr_context';
import Reviews from '@fiverr-private/reviews/src/reviews';
import SafePureComponent from '../shared/SafePureComponent';
import { BQ_CLICKED_REVIEWS_RATINGS } from '../../utils/bigQueryEvents';
import { PAGE_NAME } from '../../utils/events';
import { REVIEWS } from '../../utils/pageSections';
import TextButton from './TextButton';

import './style.scss';

const validateReviewsSnippet = (reviews) => !!(reviews && !_.isEmpty(reviews.reviews_snippet));

const ReviewsSnippet = (
    {
        reviews = {},
        scrollToSection = _.noop
    }, { biEvents }) => {

    if (!validateReviewsSnippet(reviews)) {
        return null;
    }

    const { pageCtxId } = getContext();

    const enrichData = {
        pageCtxId,
        pageName: PAGE_NAME
    };

    const { reviews_snippet: reviewsSnippet } = reviews;

    const viewMoreClick = () => {
        biEvents.sendBigQueryEvent({ eventName: BQ_CLICKED_REVIEWS_RATINGS });
        scrollToSection({ sectionKey: REVIEWS });
    };

    return (
        <div className="gig-reviews-snippet">
            <header>
                <h2 className="section-title"><I18n k={'gig_page_perseus.reviews_snippet.title'}/></h2>
                <TextButton className="reviews-button"
                    text={'gig_page_perseus.reviews_snippet.view_all'}
                    onClick={viewMoreClick}/>
            </header>
            <Reviews initialState={({ ...reviews, reviews: reviewsSnippet, ...enrichData })} asCarousel/>
        </div>
    );

};

ReviewsSnippet.propTypes = {
    reviews: object,
    scrollToSection: func
};

ReviewsSnippet.contextTypes = {
    biEvents: object
};

export { ReviewsSnippet };
export default SafePureComponent(ReviewsSnippet);
